import './App.css';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import NotFound from './components/NotFound/NotFound';
import SuperAdmin from './components/SuperAdmin/SuperAdmin';
import Login from './components/LoginSignup/Login';
import { lazy } from 'react';
import LazyImage from './components/Usables/LazyImage';
import UploadResume from './components/LoginBypassPages/UploadResume';
import { userRoutes } from './Routes/Routes';
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Dashboard = lazy(() => import("./components/Dashboard/Dashboard"));

function App() {
  const isCvUpload = window.location.href.includes("update-resume");
  const name = localStorage.getItem("name");
  const role = localStorage.getItem("role");
  const appToken = localStorage.getItem("token");;

  const mRoutes = (name && role && appToken && !isCvUpload) && role === "Super Admin" 
    ? [
        {
          element: <SuperAdmin />,
          errorElement: <NotFound />,
          ErrorBoundary: <NotFound />,
          children: userRoutes,
        },
      ]
    : (name && role && appToken && !isCvUpload)
    ? [
        {
          element: <Dashboard />,
          errorElement: <NotFound />,
          ErrorBoundary: <NotFound />,
          children: userRoutes,
        },
      ]
    : isCvUpload ?
     [{ path: '/update-resume', element: <UploadResume /> },]
    : [
        { path: '/Login', element: <Login /> },
        { path: '/', element: <Login /> },
        { path: "*", element: <Navigate to="/" replace />  },
      ];
  const router = createBrowserRouter(mRoutes);

  if (isCvUpload) {
    return (
      <>
      <div className="App customScroll">
        <RouterProvider router={router} />
      </div>
      <ToastContainer position="top-right" autoClose={3000}
      hideProgressBar={false} newestOnTop={false}
      closeOnClick rtl={false}
      pauseOnFocusLoss draggable
      pauseOnHover theme="light"
      transition={Bounce} />
    </>
    )
  }
  return (
    <>
      <div className="App customScroll hidden md:block">
        {/* All routes provider */}
        <RouterProvider router={router} />
      </div>
      {/* Show screen if thia app is open in tablet and mobile */}
      <div className='relative h-screen overflow-hidden w-full flex flex-col items-center lightBabyGreen justify-center md:hidden'>
        <div>
          <div className=' absolute darkPurple top-0 left-0 py-3 px-4 w-full flex items-center justify-between'>
            <LazyImage className=' w-40' src="/img/tcoLogo2.png" alt="No access banner" />
          </div>
        </div>
        <LazyImage className=' min-w-[14rem] max-w-[15rem]' src='/img/desktop-1.png' alt='Desktop Image' />
        <h1 className=' textDarkBlue text-2xl font-semibold'>Open website on desktop</h1>
      </div>
      {/* use to notify messages */}
      <ToastContainer position="top-right" autoClose={3000}
      hideProgressBar={false} newestOnTop={false}
      closeOnClick rtl={false}
      pauseOnFocusLoss draggable
      pauseOnHover theme="light"
      transition={Bounce} />
    </>
  );
}

export default App;
